"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_ui_1 = require("@sport-thieme/react-ui");
var react_lottie_1 = __importDefault(require("react-lottie"));
var maintenance_animation_json_1 = __importDefault(require("./maintenance-animation.json"));
var usePermission_1 = __importDefault(require("../Permission/usePermission"));
var util_localization_1 = require("@sport-thieme/util-localization");
function MaintenanceMode(_a) {
    var message = _a.message, onDismiss = _a.onDismiss;
    var classes = useStyles();
    var canDismiss = (0, usePermission_1.default)({
        service: 'graphql-app-permissions-prod',
        type: 'Mutation',
        field: '*',
    })[0];
    return (react_1.default.createElement(react_ui_1.Paper, { elevation: 10, className: classes.paper },
        react_1.default.createElement(react_ui_1.Grid, { container: true, alignItems: "center", justify: "center", direction: "column", spacing: 2 },
            react_1.default.createElement(react_ui_1.Grid, { item: true, className: classes.lottieWrapper },
                react_1.default.createElement(react_lottie_1.default, { options: {
                        loop: true,
                        autoplay: true,
                        animationData: maintenance_animation_json_1.default,
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid meet',
                        },
                    } })),
            react_1.default.createElement(react_ui_1.Grid, { item: true, className: classes.messageWrapper },
                react_1.default.createElement(react_ui_1.H3, null, "Maintenance Mode"),
                react_1.default.createElement(react_ui_1.H5, { className: classes.message }, message))),
        canDismiss && (react_1.default.createElement(react_ui_1.Tooltip, { title: (0, util_localization_1.localize)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["dismiss"], ["dismiss"]))), className: classes.closeButton },
            react_1.default.createElement(react_ui_1.IconButton, { onClick: onDismiss },
                react_1.default.createElement(react_ui_1.Icon.Close, null))))));
}
exports.default = MaintenanceMode;
var useStyles = (0, react_ui_1.makeStyles)(function (theme) { return ({
    lottieWrapper: {
        '& svg': {
            width: '600px!important',
            height: '340px!important',
            maxWidth: '80vw',
            maxHeight: '40vw',
        },
    },
    paper: {
        position: 'relative',
    },
    closeButton: {
        position: 'absolute',
        top: theme.spacing(),
        right: theme.spacing(),
    },
    messageWrapper: {
        paddingTop: 0,
        textAlign: 'center',
        transform: 'translateY(-15%)',
    },
    message: {
        maxWidth: 400,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
}); });
var templateObject_1;
//# sourceMappingURL=MaintenanceMode.js.map